/**
 * Smart shipping countdown – dansk tid (Europe/Copenhagen).
 * Scenarie 1: Hverdag før cutoff → live countdown.
 * Scenarie 2–4: Efter cutoff / weekend → statisk besked.
 * Cutoff fra theme: window.KANEL_SHIPPING_CUTOFF_HOUR (default 15).
 */
(function() {
  var TZ = 'Europe/Copenhagen';
  var WEEKDAY_NAMES = { 'mandag': 1, 'tirsdag': 2, 'onsdag': 3, 'torsdag': 4, 'fredag': 5, 'lørdag': 6, 'søndag': 0 };
  var DAY_NAMES = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  function getCopenhagenNow() {
    var d = new Date();
    var formatter = new Intl.DateTimeFormat('da-DK', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      weekday: 'long'
    });
    var parts = formatter.formatToParts(d);
    var get = function(type) { return (parts.find(function(p) { return p.type === type; }) || {}).value; };
    var weekdayStr = (get('weekday') || '').toLowerCase();
    return {
      year: parseInt(get('year'), 10),
      month: parseInt(get('month'), 10) - 1,
      day: parseInt(get('day'), 10),
      hour: parseInt(get('hour'), 10),
      minute: parseInt(get('minute'), 10),
      second: parseInt(get('second'), 10),
      weekday: WEEKDAY_NAMES[weekdayStr] !== undefined ? WEEKDAY_NAMES[weekdayStr] : (parseInt(get('weekday'), 10) || 0)
    };
  }

  function getCutoffHour() {
    var h = window.KANEL_SHIPPING_CUTOFF_HOUR;
    if (h == null || h === '') return 15;
    h = parseInt(h, 10);
    if (isNaN(h) || h < 0 || h > 23) return 15;
    return h;
  }

  /** Return { mode: 'countdown'|'static', messageKey: string, endDate: Date|null } for Copenhagen now. */
  function getState(copenhagenNow, cutoffHour) {
    var w = copenhagenNow.weekday; // 0=søn, 1=man, ..., 5=fredag, 6=lør
    var hour = copenhagenNow.hour;
    var isBeforeCutoff = hour < cutoffHour;
    var isFriday = w === 5;
    var isThursday = w === 4;
    var isMonWed = w >= 1 && w <= 3;
    var isWeekend = w === 0 || w === 6;

    if (isWeekend) {
      return { mode: 'static', messageKey: 'fri_weekend', endDate: null };
    }
    if (isFriday && !isBeforeCutoff) {
      return { mode: 'static', messageKey: 'fri_weekend', endDate: null };
    }
    if (isThursday && !isBeforeCutoff) {
      return { mode: 'static', messageKey: 'weekday', endDate: null };
    }
    if (isMonWed && !isBeforeCutoff) {
      return { mode: 'static', messageKey: 'weekday', endDate: null };
    }
    if (isFriday && isBeforeCutoff) {
      return { mode: 'countdown', messageKey: 'fri_before', endDate: null };
    }
    if (isBeforeCutoff) {
      return { mode: 'countdown', messageKey: 'mon_thu_before', endDate: null };
    }
    return { mode: 'static', messageKey: 'mon_wed_after', endDate: null };
  }

  /** Leveringsdag (0–6) når vi viser statisk besked: Man→onsdag, Tir→torsdag, Ons→fredag, Tor→mandag, Fre/Lør/Søn→tirsdag. */
  function getDeliveryWeekday(todayWeekday) {
    if (todayWeekday === 1) return 3; // man → onsdag
    if (todayWeekday === 2) return 4; // tir → torsdag
    if (todayWeekday === 3) return 5; // ons → fredag
    if (todayWeekday === 4) return 1; // tor → mandag
    return 2; // fre/lør/søn → tirsdag
  }

  /** Seconds from midnight Copenhagen until cutoff today. If negative, we're past cutoff. */
  function secondsUntilCutoffToday(copenhagenNow, cutoffHour) {
    var nowSec = copenhagenNow.hour * 3600 + copenhagenNow.minute * 60 + copenhagenNow.second;
    var endSec = cutoffHour * 3600;
    return endSec - nowSec;
  }

  function tick(el) {
    var cutoffHour = getCutoffHour();
    var copenhagenNow = getCopenhagenNow();
    var state = getState(copenhagenNow, cutoffHour);

    var countdownWrap = el.querySelector('[data-countdown-smart-timer]');
    var staticWrap = el.querySelector('[data-countdown-smart-static]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-mins]');
    var secsEl = el.querySelector('[data-countdown-secs]');
    var suffixEl = el.querySelector('[data-countdown-suffix]');
    var staticTextEl = el.querySelector('[data-countdown-smart-static-text]');

    if (!countdownWrap || !staticWrap) return;

    if (state.mode === 'static') {
      countdownWrap.style.display = 'none';
      staticWrap.style.display = 'flex';
      if (staticTextEl) {
        var msg = el.getAttribute('data-msg-' + state.messageKey) || staticTextEl.textContent;
        msg = (msg + '').replace(/\[CUTOFF\]/g, cutoffHour + ':00');
        if (state.messageKey === 'weekday') {
          var deliveryW = getDeliveryWeekday(copenhagenNow.weekday);
          msg = msg.replace(/\[DELIVERY_DAY\]/g, DAY_NAMES[deliveryW]);
        }
        staticTextEl.textContent = msg;
      }
      return;
    }

    countdownWrap.style.display = 'flex';
    staticWrap.style.display = 'none';

    var diff = secondsUntilCutoffToday(copenhagenNow, cutoffHour);
    if (diff <= 0) {
      state.mode = 'static';
      state.messageKey = isFriday(copenhagenNow) ? 'fri_weekend' : 'weekday';
      countdownWrap.style.display = 'none';
      staticWrap.style.display = 'flex';
      if (staticTextEl) {
        var msg = (el.getAttribute('data-msg-' + state.messageKey) || '').replace(/\[CUTOFF\]/g, cutoffHour + ':00');
        if (state.messageKey === 'weekday') {
          var deliveryW = getDeliveryWeekday(copenhagenNow.weekday);
          msg = msg.replace(/\[DELIVERY_DAY\]/g, DAY_NAMES[deliveryW]);
        }
        staticTextEl.textContent = msg;
      }
      return;
    }

    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    if (hoursEl) hoursEl.textContent = h + 't';
    if (minsEl) minsEl.textContent = m + 'm';
    if (secsEl) secsEl.textContent = s + 's';

    var suffix = (state.messageKey === 'fri_before')
      ? (el.getAttribute('data-suffix-fri') || 'og modtag din ordre på mandag!')
      : (el.getAttribute('data-suffix-tomorrow') || 'og modtag din ordre i morgen!');
    if (suffixEl) suffixEl.textContent = ' ' + suffix;
  }

  function isFriday(copenhagenNow) {
    return copenhagenNow.weekday === 5;
  }

  function run() {
    var els = document.querySelectorAll('[data-countdown-smart]');
    els.forEach(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { run(); setTimeout(run, 400); });
  } else {
    run();
    setTimeout(run, 400);
  }
  setInterval(run, 1000);
  document.addEventListener('product-info:loaded', run);
})();
